export default "__VITE_ASSET__DD3pKpDL__"